import axios from '@/assets/js/axios'
import Urls from '@/assets/js/Urls'

/**
 * 获取课程列表
 * @param data
 */
export function getCourseList(data, viewState) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Course/Api/SetList`,
    method: 'post',
    data,
    headers: {
      'Ykt-ViewState': viewState
    }
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 获取课程详情
 * @param {number} setId 课程id
 */
export function getCourseDetail(setId) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Course/Api/SetDetail`,
    method: 'get',
    params: {
      setId
    }
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => null)
}

/**
 * 获取课程视频的信息
 * @param {number} videoIdentity 视频id
 */
export function getPlayInfo(videoIdentity) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Course/Api/PlayInfo`,
    method: 'get',
    params: {
      videoIdentity
    }
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => null)
}

/**
 * 获取热门课程
 * @return {Promise<* | null>}
 */
export function getRecommendSetList() {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Course/Api/RecommendSetList`,
    method: 'post'
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => null)
}

/**
 * 获取课程列表
 * @return {Promise<* | null>}
 */
export function getCourseSections(data) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Course/AuthorCourse/GetCourseSections`,
    method: 'post',
    data
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => null)
}
